export default {
  computed: {
    /**
     * $eachslot('slotname')
     * Return an array of object [{slotname,slotkey}]
     * for each slots. This allow to iterate over multiple
     * slots of the same name.
     */
    $eachslot: function () {
      return (namespace) => {
        // Referencing this.$slots prevent a console warning
        const vmslots = this.$slots
        // Array with information about generated slots
        const slots = []
        // If namespace can't be found, return empty array
        if (!vmslots[namespace]) return slots
        // Each slot in this.slots namespace
        vmslots[namespace].forEach((vmnode, id) => {
          // No tag AND no text, continue
          if (!vmnode.tag && (!vmnode.text || vmnode.text.trim() === '')) {
            return
          }
          const name = `${namespace}[${id}]`
          const key = `slot-${name}`
          vmslots[name] = [vmnode]
          slots.push({ name, key })
        })
        return slots
      }
    }
  }
}
